module.exports = __webpack_public_path__ + "img/10cfd55.jpg";